/**
 * Internal dependencies
 */
import PanelTypes from '../../components/panels/design/types';
import {
  SHARED_DEFAULT_ATTRIBUTES,
  SHARED_DEFAULT_CLEARABLE_ATTRIBUTES,
} from '../shared/constants';

export const defaultAttributes = SHARED_DEFAULT_ATTRIBUTES;

export const clearableAttributes = SHARED_DEFAULT_CLEARABLE_ATTRIBUTES;

export const hasDownloadMenu = false;

export const hasDuplicateMenu = true;

export const hasDesignMenu = true;

export const hasEditMode = false;

export const hasEditModeIfLocked = false;

export const hasEditModeMoveable = false;

export const editModeGrayout = false;

export const isMedia = false;

export const canFlip = true;

export const isMaskable = false;

export const isAspectAlwaysLocked = false;

export const resizeRules = {
  vertical: true,
  horizontal: true,
  diagonal: true,
  minWidth: 20,
  minHeight: 20,
};

export const panels = [
  PanelTypes.ELEMENT_ALIGNMENT,
  PanelTypes.LAYER_STYLE,
  PanelTypes.SIZE_POSITION,
  PanelTypes.LOTTIE_PARAMETERS,
  PanelTypes.LOTTIE_PLAYBACK,
  PanelTypes.ANIMATION,
  PanelTypes.LINK,
];
